import { createContext, useContext } from 'react';

import { isEmpty } from 'lodash';

import { IUnit } from 'shared/domain/entities';

export interface IScheduleUnitContext {
  unit: IUnit | null;
  selectUnit: (unit: IUnit | null) => void;
}

export const ScheduleUnitContext = createContext({} as IScheduleUnitContext);

export const useScheduleUnit = () => {
  const context = useContext(ScheduleUnitContext);

  if (isEmpty(context)) {
    throw new Error(
      'useScheduleUnit should be called within a ScheduleUnitContext',
    );
  }

  return context;
};
